import {
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  IconButton,
  Text,
  Tooltip,
  Select,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Icon,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from "@chakra-ui/icons";
import { MdSend, MdEdit, MdSave } from "react-icons/md";

// Custom components
import Card from "components/card/Card";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
import InvoiceApi from "api/invoice";
import { toast } from "react-toastify";
import MonitorApi from "api/monitor";

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function PendingInvoiceTable({
  columnsData,
  tableData,
  fetchInvoices,
}) {
  const EditableCell = ({ value: initialValue, row, column, updateMyData }) => {
    const [value, setValue] = useState(initialValue);
  
    const onBlur = () => {
      console.log(row.original.id, column.id, value);
      
      MonitorApi.update({
        id: row.original.id,
        invoice_price: value
      }).then((res) => {
        if (res.status === 200) {
          toast.success("Account updated successfully.");
          fetchInvoices();
        }
        onClose();
      });
      console.log("Monitor API is called");
      // updateMyData(row.index, column.id, value);
    };
  
    return (
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        step="0.01" // Allows decimals
        onBlur={onBlur}
        style={{ width: '100%' }}
      />
    );
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [price, setPrice] = useState(0);
  const [monitorID, setMonitorID] = useState(0);

  const [editableRowID, setEditableRowID] = useState(0);
  const [isEditing, setIsEditing] = useState(false);

  const [columnsFromProps, setColumnsFromProps] = useState(columnsData);
  // const [tableDataFromProps, setTableDataFromProps] = useState(tableData);

  // console.log("================tableDataFromProps====>>>>>>>>>>>>>>>>>>>>")
  // console.log(tableDataFromProps);

  const columns = useMemo(() => columnsFromProps, [columnsFromProps]);
  // const data = useMemo(() => tableData, [tableData]);
  const [data, setData] = useState(tableData);

  useEffect(()=>{
    setData(tableData);
  }, [tableData])
  const editBidPrice = (id) => {

  }

  const sendInvoice = () => {
    onClose();

    toast.success(`User Activity ID: ${monitorID}`);

    InvoiceApi.send({ monitorId: monitorID, invoice_price: price }).then(
      (res) => {
        if (res.status === 200) {
          toast.success("Invoice is sent successfully.");
          fetchInvoices();
        }
      }
    );
  };

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;

  initialState.pageSize = 10;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const updateMyData = (rowIndex, columnId, value) => {
    // let newData = [...data];
    // newData[rowIndex][columnId] = value;
    // data = newData;
  };

  const editableToggle = (headerName, rowId) => {
    setEditableRowID(rowId);
    setIsEditing((isEditing) => !isEditing);

    setColumnsFromProps(columns.map(column => {
      if (column.Header == headerName) {
        return {
          ...column,
          editable: column.editable ? false : true,
        }
      }
      return column;
    }));
  }

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Pending Approvals
        </Text>
      </Flex>
      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index1) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index1}>
                {row.cells.map((cell, index) => {
                  let data = "";

                  if (cell.column.Header === "INVOICE TYPE") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value.toUpperCase()}
                      </Text>
                    );
                  } else 
                  if (cell.column.Header === "CREATED AT") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {`${new Date(
                          cell.value
                        ).toLocaleDateString()} ${new Date(
                          cell.value
                        ).toLocaleTimeString()}`}
                      </Text>
                    );
                  } else if (
                    cell.column.Header === "AUCTION" ||
                    cell.column.Header === "LOCATION"
                  ) {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value.toUpperCase()}
                      </Text>
                    );
                  } else if (
                    cell.column.Header === "BID PRICE"
                  ) {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        ${numberWithCommas(cell.value.toFixed(2))}
                      </Text>
                    );
                  } else if(cell.column.Header === "CAR INFO"){
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        ${cell.value.toUpperCase()}
                      </Text>
                    );
                  }else if (cell.column.Header === "FINAL PRICE") {
                    if (row.original.id === editableRowID) {
                      data = cell.column.editable ? (
                        data = <EditableCell
                          value={cell.value.toFixed(2)}
                          row={row}
                          column={cell.column}
                          updateMyData={updateMyData}
                        />
                      ) : (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          ${numberWithCommas(cell.value.toFixed(2))}
                        </Text>
                      )
                    }
                    else
                    {
                      data = 
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        ${numberWithCommas(cell.value.toFixed(2))}
                      </Text>
                    }
                  } else if (cell.column.Header === "ACTION") {
                    data = (
                      <span>
                        <Button
                          size="sm"
                          colorScheme="green"
                          onClick={(e) => {
                            console.log(row);
                            editableToggle("FINAL PRICE", row.original.id);
                            // setMonitorID(row.original.id);
                            // onOpen();
                          }}
                        >
                          {isEditing && row.original.id === editableRowID ? (
                            <span>
                              <Icon w="10px" h="10px" me="2px" as={MdSave} />
                              Save
                            </span>
                          ) : (
                            <span>
                              <Icon w="10px" h="10px" me="2px" as={MdEdit} />
                              Edit
                            </span>
                          )}
                        </Button>
                        <Button
                          size="sm"
                          colorScheme="red"
                          onClick={(e) => {
                            console.log(row);
                            setMonitorID(row.original.id);
                            onOpen();
                          }}
                        >
                          <Icon w="10px" h="10px" me="2px" as={MdSend} />
                          Send
                        </Button>
                      </span>
                    );
                    
                  } else {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  }

                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Flex justifyContent="space-between" m={4} alignItems="center">
        <Flex>
          <Tooltip label="First Page">
            <IconButton
              onClick={() => gotoPage(0)}
              isDisabled={!canPreviousPage}
              icon={<ArrowLeftIcon h={3} w={3} />}
              mr={4}
            />
          </Tooltip>
          <Tooltip label="Previous Page">
            <IconButton
              onClick={previousPage}
              isDisabled={!canPreviousPage}
              icon={<ChevronLeftIcon h={6} w={6} />}
            />
          </Tooltip>
        </Flex>

        <Flex alignItems="center">
          <Text flexShrink="0" mr={8}>
            Page{" "}
            <Text fontWeight="bold" as="span">
              {pageIndex + 1}
            </Text>{" "}
            of{" "}
            <Text fontWeight="bold" as="span">
              {pageOptions.length}
            </Text>
          </Text>
          <Text flexShrink="0">Go to page:</Text>{" "}
          <NumberInput
            ml={2}
            mr={8}
            w={28}
            min={1}
            max={pageOptions.length}
            onChange={(value) => {
              const page = value ? value - 1 : 0;
              gotoPage(page);
            }}
            defaultValue={pageIndex + 1}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
          <Select
            w={32}
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </Select>
        </Flex>

        <Flex>
          <Tooltip label="Next Page">
            <IconButton
              onClick={nextPage}
              isDisabled={!canNextPage}
              icon={<ChevronRightIcon h={6} w={6} />}
            />
          </Tooltip>
          <Tooltip label="Last Page">
            <IconButton
              onClick={() => gotoPage(pageCount - 1)}
              isDisabled={!canNextPage}
              icon={<ArrowRightIcon h={3} w={3} />}
              ml={4}
            />
          </Tooltip>
        </Flex>
      </Flex>

      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Send Invoice</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Invoice Price</FormLabel>
              <Input
                textColor={textColor}
                onChange={(e) => setPrice(e.target.value)}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={sendInvoice}>
              Send
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Card>
  );
}
